//
// DeleteAccountPanel
//
// Use in a popover for deleting an account.

import { observer } from 'mobx-react-lite'
import { useStore } from '../stores'

import { VView } from '../appview'
import { Header, Text } from '../components'

export const DeleteAccountDisabledPanel = observer(
    function DeleteAccountDisabledPanel() {
        const { app } = useStore()

        return (
            <VView className="actions-panel change-password-panel">
                <div className="inspector">
                    <Header className="cc-notice">{app.text('Delete account')}</Header>
                    <VView>
                        <Text>
                            {app.text(
                                'You can not delete your account while you are the owner of one or more projects. Please transfer ownership or delete those projects first.'
                            )}
                        </Text>
                    </VView>
                </div>
            </VView>
        )
    }
)
